import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapseTemplateDirective } from './collapse-template.directive';
import { CollapseComponent } from './collapse.component';


@NgModule({
  declarations: [
    CollapseComponent,
    CollapseTemplateDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CollapseComponent,
    CollapseTemplateDirective,
  ]
})
export class CollapseModule { }
